export default __webpack_public_path__ + "static/media/ding2.58c72150.mp3";